import React, { ReactElement } from "react"
import clsx from "clsx"
import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import { useObserver } from "../../../hooks/useObserver"
import scrollToPersonalForm from "../../../helpers/scrollToPersonalForm"
import * as styles from "./banner.module.scss"

interface IButtonProps {
  onClick?: () => void
  children: ReactElement | string
}

export const ButtonFloating = ({ onClick = scrollToPersonalForm, children }: IButtonProps) => {
  const isVisible = useObserver(["formPkw", "TwoChoice"])

  return (
    <div className={clsx(styles.btnBlock, { [styles.hideMobBlock]: isVisible })}>
      <Container>
        <Button onClick={onClick} className={styles.mobBtn}>
          {children}
        </Button>
      </Container>
    </div>
  )
}
